/** True when `pathname` is the landing page for the tier upgrade campaign with this slug. */
export function isTierUpgradeCampaignPath(pathname: string, slug: string): boolean {
  return pathname.replace(/\/+$/, '').endsWith(`/societe/${slug}`)
}
